import { createBrowserHistory } from 'history';

export const routerHistory = createBrowserHistory();
